import actionCreators from "./actionCreators";

export const initialState = {
    sidelinks: [],
    isLoading: false,
    errorRes: { error: "", errors: {} },
};

export default (state = initialState, { type, payload }) => {
    switch (type) {
        case actionCreators.createSidelinks.type:
            return {
                ...state,
                sidelinks: payload,
            };
        case actionCreators.errorResponse.type:
            return {
                ...state,
                errorRes: payload,
            };
        default:
            return state;
    }
};
